import { PLATFORMS_TYPES } from '@/constants';

export const getPlatformsForDropdown = (platforms, countryKey, region) => {
  // render US platforms as default for us region
  if (region === 'us' && countryKey !== 'US' && countryKey !== 'MX') {
    countryKey = 'US';
  }

  return platforms
    .filter(
      p =>
        !(
          Object.prototype.hasOwnProperty.call(p, 'type') &&
          Object.prototype.hasOwnProperty.call(p, 'supportedCountries')
        ) ||
        (p.type !== PLATFORMS_TYPES.OTHER && p.supportedCountries.includes(countryKey)),
    )
    .map(({ supportedCountries, ...p }) => p);
};
